module.exports = __webpack_public_path__ + "media/passing_touchdown_right.31327809.mp4";